import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Table, Space, Typography, Row, Col } from 'antd';
import IntlMessage from '../../components/IntlMessage';
import { useIntl } from 'react-intl';
import operatorsApi from '../../api/operators';
import IntlMessages from '../../components/IntlMessage';
import PageTitle from '../../components/PageTitle';
import ActionBar from '../../components/ActionBar';
import AddUserOperatorForm from './AddUserOperator';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const { Text } = Typography;
export default function UserOperatorsForm(props) {
  // const isMount = useRef(false);
  const { onClose, currentData, open } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const intl = useIntl();
  const [items, setItems] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [item, setItem] = useState(null);
  const [modal, setModal] = useState(false);
  const [total, setTotal] = useState(1);
  const [current_data, setCurrentData] = useState(null);
  const [userOprator, setUserOprator] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const handleCancel = () => {
    onClose();
  };
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });
  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      let items = await operatorsApi.getAllUserOperator(filter, currentData.id);

      setItems(items.data);
      setLoading(false);
      // setDeleting(false);
      if (total !== items.total) setTotal(items.total);
    }
    fetchData();
  }, [reload, currentData, filter]);

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const onReload = () => {
    setReload(!reload);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const onChangeTable = async (
    pagination,
    filters,
    sorter,
    extra = { currentDataSource: [] }
  ) => {
    setFilter({
      ...filter,
      page: pagination.current,
      limit: pagination.pageSize,
      order_dir: getOrder(sorter.order),
      order_by: sorter.columnKey ? `${sorter.columnKey}` : 'id',
    });
  };
  const getOrder = (order) => {
    if (order === 'ascend') return 'ASC';
    if (order === 'descend') return 'DESC';
    return 'DESC';
  };
  const onDelete = async (selectedRowKeys) => {
    // console.log('Deleted');
    await operatorsApi.deleteUserOperator(selectedRowKeys).catch((error) => {
      console.error(error);
      Modal.error({
        title: error.data.message,
        okText: intl.formatMessage({ id: 'global.close' }),
      });
      setLoading(false);
    });
    setSelectedRowKeys([]);
    // setDeleting(true);
    onReload();
  };

  const onOpenModal = () => {
    setOpenModal(true);
    setCurrentData(null);
  };
  const onOpenEditModal = (record) => {
    setOpenModal(true);
    setCurrentData(record);
  };

  const onModalClose = () => {
    form.resetFields();
    setOpenModal(false);
  };
  const columns = [
    {
      title: <IntlMessage id="global.firstname" />,
      key: 'firstname',
      dataIndex: 'id',
      render: (_, record) => {
        return (
          <Button
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '3px',
              color: '#14bb8c',
            }}
            onClick={() => onOpenEditModal(record)}
            type="link">
            {record?.user?.firstname}
          </Button>
        );
      },
    },
    {
      title: <IntlMessages id="global.lastname" />,
      key: 'lastname',
      sorter: true,
      dataIndex: 'lastname',
      render: (_, record) => {
        return `${record?.user?.lastname}`;
      },
    },
    {
      title: <IntlMessages id="global.email" />,
      key: 'email',
      sorter: true,
      dataIndex: 'email',
      render: (_, record) => {
        return `${record?.user?.email}`;
      },
    },
    {
      title: <IntlMessages id="global.phone" />,
      key: 'phone',
      sorter: true,
      dataIndex: 'phone',
      render: (_, record) => {
        return (
          record?.user?.mobile && (
            <Space size={4}>
              <Text>{record?.user?.mobile}</Text>
              {/* <a href={`https://zalo.me/${record.phone}`} target="_blank">
                <Image
                  style={{
                    width: '20px',
                  }}
                  preview={false}
                  src={zalo_icon}
                />
              </a> */}
            </Space>
          )
        );
      },
    },
    {
      title: <IntlMessages id="global.user_id" />,
      key: 'userId',
      dataIndex: 'userId',
      render: (text, record, index) => {
        return record?.user?.id ? record?.user?.id : 'N/A';
      },
    },
  ];
  return (
    <Modal
      title={
        currentData ? (
          <IntlMessage id="global.agency_staff" />
        ) : (
          <IntlMessage id="global.agency_staff" />
        )
      }
      open={open}
      destroyOnClose={true}
      onCancel={handleCancel}
      width="80%"
      onOk={handleCancel}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={handleCancel}>
          {<IntlMessage id="global.ok" />}
        </Button>,
      ]}>
      <Row justify="space-between">
        <Col>Agent: {currentData?.title}</Col>

        <Col>
          <ActionBar
            onDelete={() => onDelete(selectedRowKeys)}
            isShowAddButton={true}
            onAdd={onOpenModal}
            onRefresh={() => onReload()}
            isShowPublishButtons={false}
            isShowCopyButton={false}
            isShowDeleteButton={true}
            add_new={'Nouvel agent'}
            isDisabled={!(selectedRowKeys.length > 0)}></ActionBar>
        </Col>
      </Row>
      <br />
      <Table
        tableLayout="auto"
        columns={columns}
        dataSource={items}
        rowKey="id"
        size="small"
        loading={loading}
        scroll={{
          x: 'max-content',
        }}
        pagination={{
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          total: total,
          current: filter.page,
          pageSize: filter.limit,
        }}
        onChange={onChangeTable}
        rowSelection={rowSelection}
      />

      {openModal ? (
        <AddUserOperatorForm
          open={openModal}
          onClose={onModalClose}
          onReload={onReload}
          currentData={current_data?.user}
          data={currentData}
          userOprator={current_data}
        />
      ) : null}
    </Modal>
  );
}
